import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function PrivacyPolicy() {
  return (
    <div
      data-testid="privacy-policy-page"
      className="min-h-screen bg-[#0F2240] text-white"
    >
      <Header />
      <main className="pt-32 pb-20 md:pt-40 md:pb-28">
        <article className="max-w-3xl mx-auto px-6 md:px-10">
          <div className="flex items-center gap-3 mb-6">
            <div className="h-px w-10 bg-[#B89968]" />
            <span className="text-[#B89968] text-xs uppercase tracking-[0.32em]">
              Legal
            </span>
          </div>
          <h1
            data-testid="privacy-heading"
            className="font-serif-display text-4xl sm:text-5xl text-white leading-tight mb-4"
          >
            Privacy Policy
          </h1>
          <p className="text-[#94A3B8] text-sm mb-12">
            Effective Date: June 1, 2026
          </p>

          <Section title="Information We Collect">
            When you submit an inquiry through this form, we collect: your full
            name, phone number, state of residence, accident details, and
            insurance information.
          </Section>

          <Section title="How We Use Your Information">
            Your information is used solely to evaluate your potential personal
            injury case and contact you by phone to discuss legal
            representation. By submitting this form, you consent to be contacted
            by Newman Injury Law or its representatives via telephone at the
            number provided.
          </Section>

          <Section title="Data Storage &amp; Security">
            Your information is stored securely and is never sold, shared with
            third parties for marketing purposes, or used for automated SMS
            campaigns. We retain your information only as long as necessary to
            evaluate and potentially represent your case.
          </Section>

          <Section title="Your Rights">
            You may request deletion of your information at any time by
            contacting us directly.
          </Section>

          <Section title="Contact">
            Newman Injury Law
            <br />
            5700 Stirling Road, Suite 200
            <br />
            Hollywood, FL 33021
          </Section>

          <div className="mt-16 pt-8 border-t border-[#B89968]/15 flex flex-wrap gap-6 items-center">
            <Link
              to="/"
              data-testid="back-to-home"
              className="text-[#B89968] hover:text-[#CFB079] uppercase tracking-[0.22em] text-xs transition-colors"
            >
              ← Back to Home
            </Link>
            <Link
              to="/terms"
              className="text-[#94A3B8] hover:text-white uppercase tracking-[0.22em] text-xs transition-colors"
            >
              Terms of Service
            </Link>
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section className="mb-10">
      <h2 className="font-serif-display text-xl md:text-2xl text-white mb-3">
        {title}
      </h2>
      <p className="text-[#CBD5E1] leading-relaxed">{children}</p>
    </section>
  );
}
